<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M20.2572 4.11778C20.8434 6.40621 20.1914 10.6844 15.6909 14.8965C15.7211 16.2423 15.3823 18.5396 13.8333 20.358C13.7689 20.4333 13.6476 20.4024 13.6241 20.3062L12.8671 17.1555C12.6353 17.3154 12.3974 17.4754 12.1525 17.6339C12.0307 17.7127 11.867 17.6966 11.7644 17.5941L6.4454 12.2751C6.34278 12.1725 6.32721 12.0093 6.40603 11.8874C6.57635 11.6242 6.74756 11.3686 6.91953 11.1206L3.65454 10.3367C3.5581 10.3133 3.52732 10.1919 3.60276 10.1274C5.4902 8.51965 7.89344 8.21477 9.21315 8.27411C13.5683 3.66563 17.9817 3.15469 20.1823 3.85718L20.2572 4.11778ZM16.9302 7.10933C16.2389 6.41824 15.1181 6.41812 14.4269 7.10933C13.7356 7.80054 13.7358 8.92135 14.4269 9.61263C15.1181 10.3038 16.2389 10.3039 16.9302 9.61263C17.6214 8.92139 17.6213 7.8006 16.9302 7.10933Z"
              fill="#5625CC" />
        <path
            d="M8.44749 15.5921C9.27269 16.4176 9.27278 17.7553 8.44749 18.5807C7.62547 19.4027 4.30908 19.755 4.28174 19.7579C4.28174 19.7579 4.63308 16.4171 5.4585 15.5917C6.28393 14.7664 7.62209 14.7667 8.44749 15.5921Z"
            fill="url(#paint0_linear_1954_6918)" />
        <defs>
            <linearGradient id="paint0_linear_1954_6918" x1="9.06642" y1="14.9729" x2="4.28174" y2="19.7579"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#FFD52B" />
                <stop offset="1" stop-color="#FD6144" />
            </linearGradient>
        </defs>
    </svg>
</template>
<script>
export default {
    name: "AutomationIcon",
};
</script>
<style scoped>
</style>
